import { useState, useEffect,useCallback } from 'react'
import { SidebarLayoutNew } from "../components/sidebar-layout-new";
//import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/table'
import { Heading } from '../components/heading'
import { ClipboardDocumentListIcon,PhotoIcon,DocumentTextIcon } from '@heroicons/react/16/solid'; 
 
import {  } from '@heroicons/react/16/solid'; 
import { Footer } from "../components/footer";
import { BreadcrumbsNew } from "../components/breadcrumbs";
import { Fragment } from "react/jsx-runtime";
import config from '../config.js'
import { useNavigate } from 'react-router-dom';
import { PageInfo } from '../components/page-info'
import { Loader } from '../components/loader';
import { Button } from '../components/button';
import {  SuccessNotification } from '../components/notification';
import {  Pagination,  PaginationGap,  PaginationList,  
  PaginationNext,  PaginationPage,  PaginationPrevious,} from '../components/pagination'
 
import QCReportStatus from './QCReportStatus'; 
import { useSession } from '../components/session-provider'; 
 
import {  useParams } from 'react-router-dom'; 
import PerformanceChangeHistory from './PerformanceChangeHistory.js';
import ConfirmDialog from './ConfirmDialog.js';
//import { Listbox, ListboxOption } from "../components/listbox-new";
//import { Field, ErrorMessage } from '../components/fieldset'  
import { useAlert } from "../components/customAlert";
import { QCData } from './QCData.js';
const breadcrumbs_link = [{ name: "Title Test", href: "/title-test", current: false },{ name: `Title strategies`, href: "#", current: true }];
 
export default function QCReport() {
 
	  const [adwordsData, setAdwordsData]   = useState([]); 
    const [productsData, setProductsData]   = useState([]); 
    const [currentPage, setCurrentPage]   = useState(1);
    const [totalPages, setTotalPages]     = useState(1);
    const [totalRows,setTotalRows]        = useState(0);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [loading, setLoading]           = useState(false);
    const [getMainTitle,setMainTitle] = useState('');
    const [process_msg, setProcessMsg] = useState(0);
    const [successMsg] = useState('');
    const [showSuccessBox, setShowSuccessBox] = useState(false);
    const { session, setSession } = useSession();
    //const [selectedStatus, setSelectedStatus] = useState('');
    const itemsPerPage = 500;
    const { cycleMasterId } = useParams();
    const navigate = useNavigate();
    const { showAlert } = useAlert();


    const [editMode, setEditMode] = useState({});
    const [editableTitles, setEditableTitles] = useState({}); 
    const [hoveredProductId, setHoveredProductId] = useState(null);
    //const [loadedImages, setLoadedImages] = useState({});
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmAction,setConfirmAction] = useState(() => () => {});
    const [confirmMessage, setConfirmMessage] = useState('');
    const [statusinfo, setStatusInfo] = useState('');
    const [loadInfo, setLoadInfo] = useState('');
    //const [isQC, setQC] = useState('');
    //const [qcStatus, setQcStatus] = useState('');
 
    var currentCompany = session.company; 

    const breadcrumbs_link = [
    { name: currentCompany, href: "/title-test", current: false },
    { name: "Title strategies", href: "#", current: true }
    ] ;

    const getAdwordsData = useCallback(async (id, page,status) => {
    try {
      setLoading(true);
      setProcessMsg('');
      const response = await fetch(
        `${config.apiPath}/performance_process/QCDataAPI.php?page=${page}&limit=${itemsPerPage}`,
        {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id , status }),
        }
      );
      const data = await response.json();
      if (data.status === 'success') {
        setAdwordsData(data.records);
        setProductsData(data.products);
        setTotalRows(data.total_rows || 0);
 
        setTotalPages(data.total_rows ? Math.ceil(data.total_rows / itemsPerPage) : 1);
        setStatusInfo(data.status_info);
        setLoadInfo(data.load_info);
        //setQC(data.qcTest);
        setMainTitle(data.main_title);
        if (data.msg) {
          showAlert(data.msg, "Status Update" , "success",3000);
        }
         
      } else  {
          if(data.status === 'error' && data.errMsg === 'Invalid Loign Data') {
			      window.location.href = `/${config.appPath}`;
			    } else {
              showAlert("Failed to fetch adwords data", "" , "error", 3000);
               
          }
      }
      
    } catch (error) {
      showAlert("Failed to fetch adwords data", "" , "error", 3000);
    } finally {
      setIsDataLoaded(true);
      setLoading(false);
    }
  }, [itemsPerPage]);
 

    useEffect(() => {
      getAdwordsData(cycleMasterId, currentPage);
    }, [currentPage]);
 

    const handleTitleChange       = (e, key) => {setEditableTitles(prev => ({ ...prev,[key]: e.target.value}));};
    const handleMouseOver         = (id) => { setHoveredProductId(id);};
    const handleMouseOut          = () => {setHoveredProductId(null);}; 

  const handleEditTitle = async (test_cycle_id, product_id, index, uniqueKey, editTitle, key, OldTitle) => {
 
  if (editTitle.trim() === OldTitle.trim()) {
    
    showAlert("Nothing Changed", "" , "error", 3000);
    
    return;
  }
  setLoading(true);
  const url = `${config.apiPath}/performance_process/title_edit.php`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        test_cycle_id,
        product_id,
        index,
        new_title: editTitle,
        key
      })
    });

    if (!response.ok) {
      
      showAlert(`Server responded with status ${response.status}`, "" , "error", 3000);
      return;
    }

    const data = await response.json();
 
    setAdwordsData(prevData => {
      const updatedData = { ...prevData };
      const titles = updatedData[product_id]?.title;

      if (titles && Array.isArray(titles) && titles[index]) {
        titles[index].title = editTitle;
      }

      return updatedData;
    });

    //setSuccessMsg(data.msg);
    showAlert(data.msg, "Status Update" , "success",3000);
    setEditMode(prev => ({ ...prev, [uniqueKey]: false }));

    // Optional: Clear editableTitles
    setEditableTitles(prev => {
      const updated = { ...prev };
      delete updated[uniqueKey];
      return updated;
    });

  } catch (error) {
    //setErrorMsg("Failed to update title.");
    showAlert("Failed to update the title.", "" , "error", 3000);
     
  }
  setLoading(false);
};


const verifyTitle = async (test_cycle_id, product_id, index, uniqueKey, key, newStatus) => {
  //setLoading(true);
  const url = `${config.apiPath}/performance_process/title_verify.php`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        test_cycle_id,
        product_id,
        index,
        key,
        status: newStatus,
        all: false,
        tot_products_count : totalRows
      })
    });

    if (!response.ok) {
      showAlert(`Server responded with status ${response.status}`, "", "error", 3000);
      return;
    }

    const data = await response.json();
 
    setAdwordsData(prevData => {
      const updatedData = { ...prevData };

      if (updatedData[product_id] && Array.isArray(updatedData[product_id].title)) {
        const updatedTitles = updatedData[product_id].title.map(item =>
          item.key === key ? { ...item, qc_status: newStatus } : item
        );
 
        const allVerified = updatedTitles.every(
          t => t.key === 'start' || t.qc_status === 'verified'
        );

        updatedData[product_id] = {
          ...updatedData[product_id],
          qc_status: allVerified ? 'verified' : 'not verified',  
          title: updatedTitles
        };
      }

      return updatedData;
    });

    showAlert(data.msg, "Status Update", "success", 3000);

    // Reset edit mode and titles
    setEditMode(prev => ({ ...prev, [uniqueKey]: false }));

    setEditableTitles(prev => {
      const updated = { ...prev };
      delete updated[uniqueKey];
      return updated;
    });

    await refreshStatusInfo(test_cycle_id);

  } catch (error) {
    showAlert("Failed to update the title.", "", "error", 3000);
  } finally {
    //setLoading(false);
  }
};




const refreshStatusInfo = async (id) => {

  const response = await fetch(`${config.apiPath}/performance_process/qc_count_data.php`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ test_cycle_id : id})
  });
  const data = await response.json();
  if (data.status === 'success') {
    setStatusInfo(data.status_info);
  }
};
 
 const verifyAllTitles = useCallback(async (test_cycle_id, product_id, newStatus,tot_products_count) => {
  //setLoading(true);
  const url = `${config.apiPath}/performance_process/title_verify.php`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        test_cycle_id,
        product_id,
        status: newStatus,
        all: true,
        tot_products_count : totalRows
      })
    });

    if (!response.ok) {
      showAlert(`Server responded with status ${response.status}`, "", "error", 3000);
      return;
    }

    const data = await response.json();
 
    setAdwordsData(prevData => {
      const updatedData = { ...prevData };

      if (updatedData[product_id]) {
        updatedData[product_id] = {
          ...updatedData[product_id],
          qc_status: newStatus, // update top-level QC status
          title: updatedData[product_id].title.map(item =>
            item.key === 'start' ? item : { ...item, qc_status: newStatus }
          )
        };
      }

      return updatedData;
    });

    showAlert(data.msg, "Status Update", "success", 3000);

    // Refresh any summary or status info
    await refreshStatusInfo(test_cycle_id);

  } catch (error) {
    showAlert("Failed to update the title.", "", "error", 3000);
  } finally {
    //setLoading(false);
  }
}, [refreshStatusInfo, showAlert]);

const verifyAllProducts = async (test_cycle_id, newStatus,tot_products_count) => {
  setLoading(true);
  const url = `${config.apiPath}/performance_process/title_verify.php`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        test_cycle_id,
        status: newStatus,
        all_products: true,
        tot_products_count : totalRows
      })
    });

    if (!response.ok) {
      showAlert(`Server responded with status ${response.status}`, "", "error", 3000);
      return;
    }

    const data = await response.json();
 
   setAdwordsData(prevData => {
  const updatedData = { ...prevData };
  Object.keys(updatedData).forEach(product_id => {
    if (updatedData[product_id]) {
      updatedData[product_id] = {
        ...updatedData[product_id],
        qc_status: newStatus,
        title: Array.isArray(updatedData[product_id].title)
          ? updatedData[product_id].title.map(item =>
              item.key === 'start' ? item : { ...item, qc_status: newStatus }
            )
          : [],
      };
    }
  });
  return updatedData;
});

    showAlert(data.msg || "All products updated", "Status Update", "success", 3000);
    await refreshStatusInfo(test_cycle_id);

  } catch (error) {
    console.error(error);
    showAlert("Failed to update all products.", "", "error", 3000);
  } finally {
    setLoading(false);
  }
}; 


 const openDialogForProduct = (productId) => { 
    setSelectedProductId(productId);
    setIsOpen(true);
  };

const closeDialog = () => {
  setIsOpen(false);
  setSelectedProductId(null); // optional
};
 
 

    const page_info = `This title strategies summarizes key outcomes and progress achieved during the first cycle. 
    It highlights accomplishments, areas for improvement, and alignment with set objectives. 
    The report serves as a foundation for tracking growth and guiding future actions in upcoming cycles.`;
    return (
      <Fragment>
        <SidebarLayoutNew selected_menu="title-test" showsidebar="false">
          <SuccessNotification showSuccessBox={showSuccessBox} successMsg={successMsg} setShowSuccessBox={setShowSuccessBox} />
          {/*<ErrorNotification showErrorBox={showErrorBox} errorMsg={errorMsg} setShowErrorBox={setShowErrorBox} />*/}
          
          <BreadcrumbsNew pages={breadcrumbs_link} />
          <div className="flex w-full items-center gap-3 rounded-lg !pl-0 px-2 py-2.5 text-left text-base/4 font-medium text-zinc-950 sm:py-2 sm:text-sm/4 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5 *:last:data-[slot=icon]:ml-auto *:last:data-[slot=icon]:size-5 sm:*:last:data-[slot=icon]:size-4 *:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 sm:*:data-[slot=avatar]:size-6 data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950 data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950 data-current:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:*:data-[slot=icon]:fill-zinc-400 dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white dark:data-current:*:data-[slot=icon]:fill-white">
           
            <ClipboardDocumentListIcon className="!size-8" />
            <Heading className="w-full">Title strategies - {getMainTitle}</Heading>
            <Button className="-my-0.5 inline-flex justify-end gap-x-1.5 ml-auto" onClick={() => navigate("/title-test")}>Close</Button>
          </div>
          <PageInfo info={page_info} />

          {isDataLoaded ? ( <QCReportStatus statusinfo={statusinfo} cycleMasterId={cycleMasterId} getAdwordsData={getAdwordsData}  /> ) : null}
          
 
           {isDataLoaded ? (
            
            
          <div className="w-full">
             <> 
                    {process_msg && (
                        <div className="text-sm text-center text-red-500">{process_msg}</div>
                    )}
            <div>
            
           
 

    {totalRows === 0 ? (
      <div className="text-center text-sm text-gray-500 py-4"> No records found</div>
    ) : ( 
      
    <div>
      <div className="text-right mb-4">
        <button disabled={statusinfo.cycle_status?.toLowerCase() === 'started' || statusinfo.ai_status?.toLowerCase() === 'waiting' || statusinfo.ai_status?.toLowerCase() === 'failed' || statusinfo.ai_status?.toLowerCase() === 'running' }
        className={`px-3 py-1 text-white text-sm rounded-md ${statusinfo.cycle_status?.toLowerCase() === 'started' || statusinfo.ai_status?.toLowerCase() === 'waiting' || statusinfo.ai_status?.toLowerCase() === 'failed'  || statusinfo.ai_status?.toLowerCase() === 'running' ? 'bg-gray-300 cursor-not-allowed': 
                                      'bg-blue-500 cursor-pointer'}`}
          
        onClick={() => {
                setConfirmMessage('Are you sure you want to verify all Products?');
                setConfirmAction(() => () => 
                  verifyAllProducts(cycleMasterId, 'verified')
                );
                setConfirmOpen(true);
                            }}

      >
        Verify All Products
      </button>
         
      </div>
      
      
       {Object.entries(adwordsData)
  .filter(([key]) => key !== 'label_keys')
  .map(([productId, records]) => (
    <div
      key={productId}
      className="shadow-lg border-t border-t-gray-100 rounded-md bg-white dark:bg-zinc-900 p-4 pt-0 mb-6"
    >
      {/* Product Info */}
      <div className="mb-2 mt-4 flex flex-wrap items-center gap-3">
        <div className="text-sm font-semibold">
          <span className="text-gray-600">ID : </span>
          <a
            className="text-blue-600 font-bold"
            target="_blank"
            rel="noopener noreferrer"
            href={productsData[productId].direct_product_url}
          >
            {productId}
          </a>
        </div>

        {/* Hover Image */}
        <div className="relative">
          <div
            className="h-5 w-5 text-blue-500 cursor-pointer"
            onMouseOver={() => handleMouseOver(productId)}
            onMouseOut={handleMouseOut}
          >
            <PhotoIcon />
          </div>

          {hoveredProductId === productId && (
            <div className="absolute z-10 mt-2 w-100 bg-white border border-gray-200 rounded-lg shadow-lg p-2">
              <img
                src={productsData[productId].product_image_url}
                alt={`Product ${productId}`}
                className="w-full h-100 object-cover rounded-lg"
              />
            </div>
          )}
        </div>

        <div
        className="h-5 w-5 text-blue-500 cursor-pointer"
        onClick={() => openDialogForProduct(productId)}
        title="View document info"
        >
        <DocumentTextIcon />
        </div>
        {/* Status */}
        <div className={`text-sm ${records.qc_status === "verified" ? "text-green-600" : "text-red-600"}`}>
          <span className="text-gray-600">Status : </span>
           {records.qc_status.charAt(0).toUpperCase() + records.qc_status.slice(1)}
        </div>

        {selectedProductId === productId && (
  <PerformanceChangeHistory
    isOpen={isOpen}
    setIsOpen={closeDialog}
    productId={selectedProductId}
    testCycleId={cycleMasterId}
  />
)} 

      </div>
       
        
        <QCData
        records={{ ...records, productId }}
        editMode={editMode}
        editableTitles={editableTitles}
        handleTitleChange={handleTitleChange}
        handleEditTitle={handleEditTitle}
        setEditMode={setEditMode}
        cycleMasterId={cycleMasterId}
        verifyTitle={verifyTitle}
        verifyAllTitles= {verifyAllTitles} 
        statusInfo = {statusinfo}
      
      />
       
 
 
      
      </div>
      

    ))}
    </div>
  )}

{/* OBJECT ADWORDS DATA END */}
      <ConfirmDialog  open={confirmOpen}  onClose={() => setConfirmOpen(false)}  onConfirm={confirmAction} message={confirmMessage}/>
            </div>
               
            {Object.keys(adwordsData).length > 0 && (
              <div className="text-sm mt-4 text-gray-700 dark:text-gray-300">
                Showing {(currentPage - 1) * itemsPerPage + 1} - 
                {Math.min(currentPage * itemsPerPage, totalRows)} of {totalRows} Products
              </div>
                               
            )}
           
            {Object.keys(adwordsData).length > 0 && (
          
            <Pagination className="justify-center">
                <PaginationPrevious
                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                />
            
            <PaginationList> 
              <PaginationPage
                key={1}
                current={1 === currentPage}
                onClick={() => setCurrentPage(1)}
              >
                1
              </PaginationPage>
             
              {currentPage > 4 && <PaginationGap />}
            
              {/* Pages before current */}
              {Array.from({ length: 3 }, (_, i) => currentPage - 2 + i)
                .filter(page => page > 1 && page < currentPage)
                .map(page => (
                  <PaginationPage
                    key={page}
                    current={page === currentPage}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </PaginationPage>
                ))}
             
              {currentPage !== 1 && currentPage !== totalPages && (
                <PaginationPage
                  key={currentPage}
                  current
                  onClick={() => setCurrentPage(currentPage)}
                >
                  {currentPage}
                </PaginationPage>
              )} 
              {Array.from({ length: 2 }, (_, i) => currentPage + i + 1)
                .filter(page => page < totalPages)
                .map(page => (
                  <PaginationPage
                    key={page}
                    current={page === currentPage}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </PaginationPage>
                ))}
             
              {currentPage < totalPages - 3 && <PaginationGap />}
              
              {totalPages > 1 && (
                <PaginationPage
                  key={totalPages}
                  current={currentPage === totalPages}
                  onClick={() => setCurrentPage(totalPages)}
                >
                  {totalPages}
                </PaginationPage>
              )}
            </PaginationList>
            
              
                <PaginationNext
                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                  disabled={currentPage === totalPages}
                />
              </Pagination>  )}
              
              <div className="flex justify-end"><Button  onClick={() => navigate("/title-test")}>Close</Button></div>
               
            </>
            
          </div>   
          
          
         ) : <Loader />
        }
      {loading && (
        <Loader />
      )}                 
        </SidebarLayoutNew>
        <Footer />
      </Fragment>
    ); 
}